/**
 * A spell card used in both MagicSelectOverlay (choose a spell) and
 * MagicScreen (spell catalogue).
 *
 * Props:
 *   spell        — spell object (id, icon, label, desc, cooldown)
 *   rarityLabel  — rarity string to display at the top (overlay mode)
 *   rarityColor  — CSS color for rarity badge (overlay mode)
 *   badgeText    — slot-number badge shown when the spell is already equipped (catalogue mode)
 *   desc         — override description (e.g. upgrade-level desc in overlay mode)
 *   isSelectable — adds --selectable modifier when a slot is selected (catalogue mode)
 *   isEquipped   — adds --equipped modifier when spell is in a slot (catalogue mode)
 *   onClick      — click handler
 */
export function MagicSpellCard({ spell, rarityLabel, rarityColor, badgeText, desc, isSelectable, isEquipped, onClick }) {
  return (
    <button
      className={`magic-spell-card${isSelectable ? ' magic-spell-card--selectable' : ''}${isEquipped ? ' magic-spell-card--equipped' : ''}`}
      style={rarityColor ? { '--rarity-color': rarityColor } : undefined}
      onClick={onClick}
    >
      {badgeText != null && (
        <span className="magic-spell-badge">{badgeText}</span>
      )}
      {rarityLabel && (
        <div className="magic-spell-rarity" style={{ color: rarityColor }}>{rarityLabel}</div>
      )}
      <span className="magic-spell-icon">{spell.icon}</span>
      <strong className="magic-spell-name">{spell.label}</strong>
      <span className="magic-spell-cd">⏱ {spell.cooldown / 1000}s cooldown</span>
      <span className="magic-spell-desc">{desc ?? spell.desc}</span>
    </button>
  );
}
